import { render, staticRenderFns } from "./BasicMarquee.vue?vue&type=template&id=08c95d16&scoped=true&"
import script from "./BasicMarquee.vue?vue&type=script&lang=js&"
export * from "./BasicMarquee.vue?vue&type=script&lang=js&"
import style0 from "./BasicMarquee.vue?vue&type=style&index=0&id=08c95d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c95d16",
  null
  
)

export default component.exports